import { render, staticRenderFns } from "./menu-user-view.vue?vue&type=template&id=4eedc704&"
import script from "./menu-user-view.vue?vue&type=script&lang=js&"
export * from "./menu-user-view.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports